import { queryOptions, useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api-client'
import { QueryConfig } from '@/lib/react-query'

export type AccountUser = {
    id: string
    name: string
    email: string
    userRole?: number
    status?: number
    lastLogin?: string | null
}

export const getAccountUsers = (accountId: string): Promise<AccountUser[]> => {
    return api.get(`/customers/${accountId}/users`)
}

export const getAccountUsersQueryOptions = (accountId: string) => {
    return queryOptions({
        queryKey: ['accounts', accountId, 'users'],
        queryFn: () => getAccountUsers(accountId),
    })
}

type UseAccountUsersOptions = {
    accountId: string
    queryConfig?: QueryConfig<typeof getAccountUsers>
}

export const useAccountUsers = ({ accountId, queryConfig }: UseAccountUsersOptions) => {
    return useQuery({
        ...getAccountUsersQueryOptions(accountId),
        ...queryConfig,
    })
}


